module.exports = __webpack_public_path__ + "img/rnd_cors_bolt.prt.86e648ff.jpg";